var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"pageMain",class:_vm.globalDataArray.siteInfo.greyOut == 1 ? 'bigEventGray' : ''},[_c('div',{staticClass:"four"},[_vm._m(0),_c('p',{staticClass:"fnt_24"},[_vm._v(_vm._s(_vm.globalDataArray.siteTemplateLanguage.page_nofound))])])])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"four_mine"},[_c('img',{attrs:{"src":require("@/assets/images/404.jpg"),"alt":""}})])
}]

export { render, staticRenderFns }